import { auth, db } from "firebaseApp";
import { addDoc, collection, query, where } from "firebase/firestore";
import { useEffect } from "react";
import { useCollection } from "react-firebase-hooks/firestore";
import { useDispatch } from "react-redux";
import { botActions } from "store/bot";
import { gpt4o } from "utils/modelUtils";
import { COLLECTIONS } from "firebaseCollections";
import { modalsActions } from "store/react-lib/generic-ui/modals";
import { MODALS } from "modals";

export default function BotLoader() {

  const uid = auth.currentUser?.uid;
  
  const dispatch = useDispatch();
  
  const q = uid ? query(
    collection(db, COLLECTIONS.bots),
    where("uid", "==", uid),
  ) : null;

  const [snapshot, loading, error] = useCollection(q);

  if(error) {
    console.log(error);
  }

  useEffect(() => {
    if(snapshot) {
      const bots = snapshot.docs.map((doc) => ({...doc.data(), id: doc.id}));
      if(bots.length === 0) {
        dispatch(modalsActions.openModal(MODALS.onboardingModal));
      } else {
        dispatch(botActions.initialize(bots.sort((x, y) => x.createdAt - y.createdAt)));
      }
    }
  }, [snapshot]);

  return null;

}
